import { QueryClient } from '@tanstack/react-query'

const mensagemDoErro = (response) => {
  const data = response?.response?.data ?? response?.data

  if (typeof data?.error === 'string') return data.error
  if (typeof data?.msg === 'string') return data.msg
  if (Array.isArray(data)) return data[0]

  return null
}

// LIB-1790 - Os services desta pasta engolem o erro: o `.catch(({...r}) => r)`
// devolve o proprio objeto do axios em vez de rejeitar. Para o React Query saber
// que a requisicao falhou (e nao cachear lixo como se fosse dado bom), toda
// queryFn precisa passar a resposta por aqui.
export const unwrapApi = (response) => {
  if (response?.status === 200 || response?.status === 201) {
    return response.data
  }

  const erro = new Error(mensagemDoErro(response) || 'Erro na requisicao')
  // Guardado para o onError poder reaproveitar o ToastError, que sabe abrir
  // tanto o formato do axios quanto o `{ error: '...' }` do back.
  erro.apiResponse = response
  erro.status = response?.status ?? response?.response?.status
  throw erro
}

const ehErroDoCliente = (error) => {
  const status = error?.status
  return status >= 400 && status < 500
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Listas: 30s de "fresco" cobre o vai-e-volta tipico entre quadro e ficha
      // sem deixar o usuario olhando dado velho. Detalhe da ficha e selects
      // sobem esse valor na propria query.
      staleTime: 30 * 1000,
      // Tempo que o dado fica no cache depois de ninguem mais usar. E o que faz
      // reabrir uma ficha/quadro ja visitado aparecer na hora.
      cacheTime: 10 * 60 * 1000,
      // O HUB fica aberto o dia todo em varias abas; refetch a cada foco de
      // janela geraria uma enxurrada de requisicoes. Quem precisa (as listas)
      // liga isso na propria query.
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      // 401/403/422 nao melhoram na segunda tentativa - so atrasam o erro.
      retry: (falhas, error) => (ehErroDoCliente(error) ? false : falhas < 1),
      retryDelay: (falhas) => Math.min(1000 * (2 ** falhas), 5000)
    },
    mutations: {
      retry: 0
    }
  }
})
